// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  MdDelete,
} from 'react-icons/lib/md';

import _ from 'lodash';
import i18n from 'i18n-js';

import type { ID_TYPE } from '../../types/common';
import * as selectors from '../../reducers';
import DataTable from '../DataTable';
import TextColumn from '../DataTable/Columns/Text';
import ButtonColumn from '../DataTable/Columns/Button';
import * as closeableActions from '../../actions/closeable';
import { FullLoader } from '../Loader';
import Popup from '../Popup';
import ConfirmDeletionPopup from '../ConfirmDeletionPopup';
import * as busActions from '../../actions/buses';
import type { BUS_TYPE } from '../../types/buses';
import { Loading, ConfirmDeletion } from '../CommonTexts';
import PlaceholderView from '../PlaceholderViews';
import PlacehorderImage from '../../../assets/images/routesph.png';

// import styles from './routesListCard.css';


type BusListTablePropTypes = {
  onSearch: Function,
  buses: Array<BUS_TYPE>,
  popupAction: Function,
  currentBus: BUS_TYPE,
  updateBus: Function,
  isFetchingBuses: boolean,
};

class BusListTable extends React.Component <BusListTablePropTypes> {
  componentWillMount() {
    const { onSearch } = this.props;

    // Load initial values
    onSearch();
  }

  render() {
    const {
      buses,
      popupAction,
      currentBus,
      updateBus,
      isFetchingBuses,
    } = this.props;
    return (
      <Fragment>
        {
          !isFetchingBuses
          && buses.length === 0
          && (
            <PlaceholderView
              image={PlacehorderImage}
              title={"NO parecen haber rutas que mostar"}
              subtitle={'No messages in your inbox, just like every other day. Get some life, dude.'}/>
          )
        }
        {
          isFetchingBuses && (
            <FullLoader
              tint="main"
              title={Loading(i18n.t('common.bus', { count: 2 }))}
            />
          )
        }
        {
          !isFetchingBuses
          && buses.length > 0
          && (
            <Fragment>
              <Popup
                id="confirmDeleteBus"
                theme="main"
                transitionType="slideDown"
                transitionMs={600}
              >
                {currentBus // El current bus ya salio del estado inicial?
                  ? (<ConfirmDeletionPopup
                    onConfirm={() => popupAction()}
                    Icon={MdDelete}
                    descriptionText={ConfirmDeletion(currentBus.code_name)}
                  />) : (<Fragment />) }
              </Popup>
              <DataTable
                data={buses}
                columns={
                  [
                    TextColumn({
                      Header: 'Bus',
                      accessor: 'code_name',
                      maxWidth: 100,
                      isHighlight: true,
                      editable: true,
                      onChange: (original, code_name) => updateBus({ ...original, code_name }),
                    }),
                    TextColumn({
                      Header: i18n.t('labels.plates'),
                      accessor: 'plates',
                      editable: true,
                      onChange: (original, plates) => updateBus({ ...original, plates }),
                    }),
                    TextColumn({
                      Header: i18n.t('labels.capacity'),
                      accessor: 'max_passengers',
                      editable: true,
                      onChange: (original, max_passengers) => updateBus({ ...original, max_passengers }),
                    }),
                    TextColumn({
                      Header: i18n.t('labels.year'),
                      accessor: 'year',
                      editable: true,
                      onChange: (original, year) => updateBus({ ...original, year }),
                    }),
                    TextColumn({
                      Header: i18n.t('labels.route', { count: 2 }),
                      accessor: 'related_routes',
                      editable: true,
                      onChange: (original, related_routes) => updateBus({ ...original, related_routes }),
                    }),
                    ButtonColumn({
                      Header: '',
                      accessor: 'remove_button',
                      buttonProps: {
                        Icon: MdDelete,
                        title: '',
                        size: 'small',
                        isTransparent: true,
                        tint: 'error',
                        isOutlined: true,
                        iconPosition: 'right',
                      },
                      maxWidth: 50,
                    }),
                  ]
                }
                minRows={0}
                showPagination={false}
              />
            </Fragment>
          )
        }
      </Fragment>
    );
  }
}

export default connect(
  (state, { id }) => {
    const profile = selectors.getProfileOfType(state, 'admin');
    const buses = selectors.getBuses(state);
    return {
      id,
      buses,
      schoolId: profile && profile.school ? profile.school : -1,
      currentBus: selectors.getCurrentBus(state),
      isFetchingBuses: selectors.getBusIsFetching(state),
    };
  },
  dispatch => ({
    onSearch(schoolId: number, text?: string) {
      dispatch(busActions.fetchSchoolBusesStarted(schoolId, text));
    },
    buttonSelectBus(busID: ID_TYPE) {
      dispatch(busActions.selectBus(busID));
    },
    remove(id: number, popupID: string) {
      dispatch(busActions.busDeleteStarted(id));
      dispatch(closeableActions.close(popupID));
    },
    openPopup(id) {
      dispatch(closeableActions.open(id));
    },
    updateBus(bus) {
      dispatch(busActions.updateBusStarted(bus));
    },
  }),
  ({
    schoolId, buses, currentBus, ...stateProps
  }, {
    onSearch, remove, openPopup, buttonSelectBus, ...dispatchProps
  }, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    currentBus,
    popupAction() {
      remove(currentBus.id, 'confirmDeleteBus');
    },
    buses: buses.map(
      element => ({
        ...element,
        remove_button: {
          onClick: () => {
            buttonSelectBus(element.id);
            openPopup('confirmDeleteBus');
          },
        },
      }),
    ),
    onSearch(text: string) {
      onSearch(schoolId, text);
    },
  }),
  {
    areStatesEqual(next, prev) {
      return _.isEqual(next.buses, prev.buses);
    },
  },
)(BusListTable);



// WEBPACK FOOTER //
// ./src/scripts/components/BusListTable/index.jsx